import type {
  CameraDetailResponse,
  CameraID,
  CameraListResponse,
  CreateCameraPayload,
  CreateCameraResponse,
  DeleteCameraResponse,
  UpdateCameraParams,
  UpdateCameraPayload,
  UpdateCameraResponse,
} from '@/domains/asset-management/types/camera';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

const toUrlID = (id: string | number): string => String(id);

export const fetchCameraList = async (params: string = ''): Promise<CameraListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.cctvManagementList(params)}`;
  return await request.get(url);
};

export const fetchDetailCamera = async (cctvId: CameraID): Promise<CameraDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailCctvManagement(toUrlID(cctvId))}`;
  return await request.get(url);
};

export const deleteCamera = async (cctvId: CameraID): Promise<DeleteCameraResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteCctvManagement(toUrlID(cctvId))}`;
  return await request.delete(url);
};

export const createCamera = async (
  cameraData: CreateCameraPayload
): Promise<CreateCameraResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createCctvManagement}`;
  return await request.post(url, cameraData);
};

export const updateCamera = async (
  cameraData: UpdateCameraPayload,
  params: UpdateCameraParams
): Promise<UpdateCameraResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateCctvManagement(toUrlID(params.cctv_id))}`;
  return await request.put(url, cameraData);
};
